import React, { createContext, useContext } from 'react';

export const CampaignWorkspaceContext = createContext({
  campaign: null,
  campaignId: '',
  loading: false,
  error: null,
  reloadCampaign: async () => {},
  canManageCampaigns: false,
});

export function useCampaignWorkspace() {
  return useContext(CampaignWorkspaceContext);
}

export function CampaignWorkspaceProvider({ value, children }) {
  return (
    <CampaignWorkspaceContext.Provider value={value}>
      {children}
    </CampaignWorkspaceContext.Provider>
  );
}
